<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('safe.language') }}
      </div>
    </div>
    <div class="wrap_box">
      <div
        class="item"
        @click="changeLang('ms_my',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ms_my.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            Español
          </div>
        </div>
        <div v-if="lang=='ms_my'">
          ✓
        </div>
      </div>
		
		
      <div
        class="item"
        @click="changeLang('en_us',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/en_us.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            English
          </div>
        </div>
        <div v-if="lang=='en_us'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('vi_vn',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/vi_vn.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            Người việt nam
          </div>
        </div>
        <div v-if="lang=='vi_vn'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('zh_hk',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/zh_hk.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            العربية
          </div>
        </div>
        <div v-if="lang=='zh_hk'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('ko_kr',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ko_kr.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            한국어
          </div>
        </div>
        <div v-if="lang=='ko_kr'">
          ✓
        </div>
      </div>
      
			
      <div
        class="item"
        @click="changeLang('id_ind',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/id_ind.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            Indonesia
          </div>
        </div>
        <div v-if="lang=='id_ind'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('th_th',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/th_th.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            ภาษาไทย
          </div>
        </div>
        <div v-if="lang=='th_th'">
          ✓
        </div>
      </div>

      <div
        class="item"
        @click="changeLang('ja_jp',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ja_jp.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            日本語
          </div>
        </div>
        <div v-if="lang=='ja_jp'">
          ✓
        </div>
      </div>
			
  
      <div
        class="item"
        @click="changeLang('pt_br',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/pt_br.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            Brasil
          </div>
        </div>
        <div v-if="lang=='pt_br'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('zh_cn',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/zh_hk2.png"></div>
          <div
            class="info"
            style="font-size: 12px !important;"
          >
            繁體中文
          </div>
        </div>
        <div v-if="lang=='zh_cn'">
          ✓
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	export default {
		name: "Language",
		data() {
			return {
				lang:this.$i18n.locale||"en_us",
			};
		},
		created() {
		},
		mounted() {
		},
		methods: {
			changeLang(lang) {
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				Toast.loading({
					// mask: true,
					message: this.$t('utils.loading'),
					duration: 200
				})
				this.$router.go(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	
	.wrap_box{
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 0 0 5px 5px;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ECECEC;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
			.right{
				width: 20px;
				height: 20px;
				background: url(../images/user/arrow.png) no-repeat center center;
				background-size: 100% 100%;
			}
			.right_info{
				color: rgba(0,0,0,.6);
			}
			.tips{
				color: rgba(0,0,0,.6);
				margin-left: auto;
				margin-right: 4px;
				font-weight: normal;
			}
			.left{
				img{
					width: 33px;
					margin-top: 5px;
				}
			}
		}
	}
	.basic_wrap { min-height: 100vh; box-sizing: border-box; background: #f5f5f5; padding-bottom: calc(var(--app-bottom-menu-height) + 16px + env(safe-area-inset-bottom, 0px)); }
	.red_top_bg { height: 50px; position: relative; background: #fff; border-bottom: 1px solid #eceff2; }
	.back_left { filter: brightness(0); opacity: 1; }
	.big_tit { top: 13px; color: #1d2d43; font-size: 16px; font-weight: 500; }
	.wrap_box { margin-top: 14px; padding: 0 22px; border-radius: 0; background: #fff; }
	.wrap_box .item { width: 100%; height: 74px; box-sizing: border-box; align-items: center; padding: 0 2px; color: #ee4d2d; font-size: 18px; font-weight: 600; line-height: normal; }
	.wrap_box .item > div:last-child { padding: 8px; color: #ee4d2d; font-size: 22px; font-weight: 500; line-height: 1; }
	.wrap_box .item .left { min-width: 0; }
	.wrap_box .item .left img { width: 34px; height: 34px; margin-top: 0; vertical-align: middle; }
	.wrap_box .item .info { margin-left: 18px; color: inherit; }
	.wrap_box { margin-top: 10px; padding: 0 16px; }
	.wrap_box .item { height: 60px; color: #333; font-size: 12px; font-weight: 400; }
	.wrap_box .item > div:last-child { color: #ee4d2d; font-size: 20px; }
	.wrap_box .item .left img { width: 28px; height: 28px; border-radius: 50%; object-fit: cover; }
	.wrap_box .item .info { margin-left: 12px; font-size: 12px !important; line-height: 18px; }
</style>
